import { EntityTileProps } from '../../../../layout/interfaces/tile';
import { Destination, DestinationStatus } from '../../interfaces/destination';

export function ExistingEdgeDestinationTilesFactory(destinations: Destination[]): Array<EntityTileProps> {
  return destinations.map((destination, index) => ({
    id: destination.id.toString(),
    errored: destination.status.value === DestinationStatus.FAILED,
    sortOrder: index,
    thumbnail: destination.destinationType.logo,
    darkModeThumbnail: destination.destinationType.logoDarkMode,
    title: destination.name,
    data: destination,
    metaData: {
      isEdge: true,
      enterpriseNodeLogo: true,
      primaryColor: null,
      darkModePrimaryColor: null
    }
  }));
}
